import React, { useState, useEffect } from "react"

/**
 * Fetches full program list and attaches users completion data to response
 * acts as cache for updates in real time
 * Used in program homepage as well as interactive view
 * @returns { programListWithUserCompletion, areProgramsLoading, error }
 */
const useSchoolFilteredProgramsDB = (firebase, subdomainSchoolId) => {
  const [programListWithUserCompletion, setProgramListWithUserCompletion] = useState([])
  const [areProgramsLoading, setAreProgramsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!firebase) {
      setAreProgramsLoading(false) // Stop loading if no programId or firebase connection
      return
    }

    let isMounted = true // Prevent state updates on unmounted components

    const fetchData = async () => {
      try {
        setAreProgramsLoading(true)
        const res = await firebase?.getSchoolFilteredProgramsWithUserProgress(subdomainSchoolId)
        
        if (isMounted) {
          setProgramListWithUserCompletion(res?.data?.programs)
        }
      } catch (err) {
        if (isMounted) {
          setError(err)
        }
      } finally {
        if (isMounted) {
          setAreProgramsLoading(false)
        }
      }
    }

    fetchData()

    return () => {
      isMounted = false // Cleanup function to prevent state updates after unmount
    }
  }, [firebase])

  return { programListWithUserCompletion, areProgramsLoading, error }
}

export default useSchoolFilteredProgramsDB
